import { apiClient } from './axios';

async function addReport(body) {
  try {
    const report = await apiClient.post('/report', body);
    return report;
  } catch {
    return null;
  }
}

async function getReport(id) {
  try {
    const report = await apiClient.get(`/report/${id}`);
    return report;
  } catch {
    return null;
  }
}

async function getReportsByStudent(studentId) {
  return apiClient.get(`reports/${studentId}`)
    .then((reports) => {
      if (reports.status === 200) {
        return reports;
      }
      return null;
    })
    .catch(() => null);
}

async function getReportsByStudentAndLanguage(studentId, languageId) {
  return apiClient.get(`report/language/${studentId}/${languageId}`)
    .then((reports) => {
      if (reports.status === 200) {
        return reports;
      }
      return null;
    })
    .catch(() => null);
}

async function getReportByStudent(studentId, coursePlanId) {
  return apiClient.get(`report/student/${studentId}/${coursePlanId}`)
    .then((report) => {
      if (report.status === 200) {
        return report;
      }
      return null;
    })
    .catch(() => null);
}

async function updateReport(reportId, body) {
  return apiClient.put(`report/${reportId}`, body)
    .then((report) => report)
    .catch(() => null);
}

const reportServices = {
  addReport,
  getReport,
  getReportByStudent,
  getReportsByStudent,
  getReportsByStudentAndLanguage,
  updateReport,
};

export default reportServices;
